import { render, staticRenderFns } from "./PonConsultaFichaPonto.vue?vue&type=template&id=5ede1141&"
import script from "./PonConsultaFichaPonto.vue?vue&type=script&lang=js&"
export * from "./PonConsultaFichaPonto.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./PonConsultaFichaPonto.vue?vue&type=style&index=1&id=5ede1141&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports